
import { DiscoverFarmCard } from "./DiscoverFarmCard";

interface Farm {
  id: number;
  name: string;
  username: string;
  avatar: string;
  cover: string;
  location: {
    lat: number;
    lng: number;
    address: string;
  };
  crops: string[];
  distance: string;
  description: string;
  verified: boolean;
  category: string;
  calculatedDistance?: number;
  plantHardinessZone: string;
  userId?: string;
}

interface DiscoverFarmListProps {
  farms: Farm[];
  onFarmClick: (farm: Farm) => void;
  isLiteMode?: boolean;
}

export const DiscoverFarmList = ({ farms, onFarmClick, isLiteMode = false }: DiscoverFarmListProps) => {
  return (
    <div className="grid grid-cols-2 gap-2 sm:gap-3">
      {farms.map((farm) => (
        <DiscoverFarmCard
          key={farm.id}
          farm={farm}
          onVisit={onFarmClick}
          isLiteMode={isLiteMode}
        />
      ))}
    </div>
  );
};
